export default function FuncionSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Recognize function families from how they behave
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Function classification is one of the most useful skills in
        intermediate math — being able to look at a graph or a few data
        points and say "that's exponential" or "that's a square root" or
        "that's logarithmic." Most curricula teach the formulas (y = aˣ,
        y = √x, y = log x) before teaching the visual identification, and
        students end up able to solve problems they can't recognize. Funcion
        works the other direction. You see how a function behaves under
        specific queries (input x, get y), and you have to identify which
        of ten families it belongs to.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The ten families
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Linear, quadratic, cubic, exponential growth, exponential decay,
        logarithmic, square root, reciprocal, sinusoidal, and absolute
        value. These ten cover most of the functional behavior you'll
        encounter in pre-calc through early calculus. The game generates
        a hidden function from one family, you query it (pick an x, see
        the y), and after as many queries as you want, you guess which
        family. The test suite verifies the 10 families are pairwise
        distinguishable across 300 random matchups, so unlike a guessing
        game where two families could be ambiguous, here there's always
        a query sequence that uniquely identifies the right answer.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What the strategy looks like
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Good function-identification has a small set of moves. Query at
        x = 0 first — if it's defined, that rules out logarithm and
        reciprocal. Query at x = 1 and x = 2 — the ratio tells you about
        exponential vs polynomial. Query a negative — if it's defined,
        that rules out square root. Two or three well-chosen queries beat
        twenty random ones. The game rewards efficient querying with a
        higher score, which teaches that the *order* of your questions
        matters more than the *number* of them.
      </p>
    </>
  );
}
